export type IdentityAvatarSize = 'md' | 'xl';

export const IDENTITY_GRID_GAP_CLASSES: Record<IdentityAvatarSize, string> = {
    md: 'gap-2',
    xl: 'gap-4',
};

export const IDENTITY_GRID_UNLABELLED_COLUMN_CLASSES: Record<
    IdentityAvatarSize,
    Record<number, string>
> = {
    md: {
        3: 'grid-cols-[repeat(3,minmax(56px,64px))]',
        4: 'grid-cols-[repeat(4,minmax(56px,64px))]',
        5: 'grid-cols-[repeat(5,minmax(56px,64px))]',
    },
    xl: {
        3: 'grid-cols-[repeat(3,minmax(80px,88px))]',
        4: 'grid-cols-[repeat(4,minmax(80px,88px))]',
        5: 'grid-cols-[repeat(5,minmax(80px,88px))]',
    },
};

export const IDENTITY_GRID_LABELLED_COLUMN_CLASSES: Record<
    IdentityAvatarSize,
    Record<number, string>
> = {
    md: {
        3: 'grid-cols-[repeat(3,minmax(56px,1fr))]',
        4: 'grid-cols-[repeat(4,minmax(56px,1fr))]',
        5: 'grid-cols-[repeat(5,minmax(56px,1fr))]',
    },
    xl: {
        3: 'grid-cols-[repeat(3,minmax(80px,1fr))]',
        4: 'grid-cols-[repeat(4,minmax(80px,1fr))]',
        5: 'grid-cols-[repeat(5,minmax(80px,1fr))]',
    },
};

export const IDENTITY_CELL_SQUARE_CLASSES = 'aspect-square w-full';

export const IDENTITY_CELL_BUTTON_CLASSES =
    'flex min-w-0 flex-col items-center justify-center gap-2 outline-none';

export const IDENTITY_GRID_MAX_HEIGHT_CLASSES: Record<
    IdentityAvatarSize,
    Record<number, string>
> = {
    md: {
        1: 'max-h-[76px]',
        2: 'max-h-[148px]',
        3: 'max-h-[220px]',
        4: 'max-h-[292px]',
        5: 'max-h-[364px]',
        6: 'max-h-[436px]',
        7: 'max-h-[508px]',
    },
    xl: {
        1: 'max-h-[100px]',
        2: 'max-h-[204px]',
        3: 'max-h-[308px]',
        4: 'max-h-[412px]',
        5: 'max-h-[516px]',
        6: 'max-h-[620px]',
        7: 'max-h-[724px]',
    },
};
